
// Generated with baseline-styles - Do not modify.
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.styles = {
    "link": "link-ea6924f9"
};
exports.styleSource = ".link-ea6924f9{position:relative;text-decoration:none;cursor:pointer}";
exports.default = exports.styles;
            
module.moduleType = "style";
